import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {Range} from 'rc-slider';

const Slider = (props) => {
  const [state, setState] = useState({
    lMin: props.initialMin,
    lMax: props.initialMax,
    handle: props.handle
  });

  const maxHandleMoved = (val) => {
    if ( val !== state.lMax ) {
      return true;
    }
  };

  const minHandleMoved = (val) => {
    if ( val !== state.lMin ) {
      return true;
    }
  };

  const handleSliderDrag = (val) => {
    if (minHandleMoved(val[0].toString())) {
      setState((props) => ({ ...props, lMin: val[0].toString(), handle: 'min' }));
      props.onChange('min', val[0]);
    }
    if (maxHandleMoved(val[1].toString())) {
      setState((props) => ({ ...props, lMax: val[1].toString(), handle: 'max' }));
      props.onChange('max', val[1]);
    }
  };

  const handleSliderFinish = (val) => {
    if (state.handle === 'min' ){
      props.onAfterChange('min', val[0].toString());
    } else {
      props.onAfterChange('max', val[1].toString());
    }
  };

    return (
      <Range
        min={parseInt(props.min)}
        max={parseInt(props.max)}
        value={props.value}
        marks={props.marks}
        onChange={handleSliderDrag}
        onAfterChange={handleSliderFinish}
      />
    );
};

Slider.defaultProps = {
  handle: '',
  initialMin: '',
  initialMax: '',
  marks: {},
};

Slider.propTypes = {
  /** Customized handle */
  handle: PropTypes.string,
  /** Initial value of the maximum */
  initialMax: PropTypes.string,
  /** Initial value of the minimum */
  initialMin: PropTypes.string,
  /** Maximum value of the slider */
  max: PropTypes.number.isRequired,
  /** Custom slider marks */
  marks: PropTypes.objectOf(PropTypes.string),
  /** Minimum value of the slider */
  min: PropTypes.number.isRequired,
  /** ontouchend or onmouseup event listener */
  onAfterChange: PropTypes.func.isRequired,
  /** onChange event listener */
  onChange: PropTypes.func.isRequired,
  /** Selected value range */
  value: PropTypes.arrayOf(PropTypes.number),
};

export default Slider;
